import styled from 'styled-components';

export const SaleItemList = styled.div``;
export const SaleItem = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
`;

export const SaleItemInfo = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ProductName = styled.div`
  font-size: 16px;
  font-weight: 700;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
  color: #595959;
`;

export const SaleItemLabelValue = styled.div`
  display: flex;
  justify-content: space-between;

  font-size: 13px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  color: #595959;
`;

export const PurchaseResume = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ResumeValue = styled.div`
  display: flex;
  justify-content: space-between;

  font-size: 16px;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
  color: #595959;
`;

export const Total = styled.div`
  display: flex;
  justify-content: space-between;

  font-size: 28px;
  font-weight: 700;
  line-height: 34px;
  letter-spacing: 0em;
  text-align: right;
  color: #4d4d4d;
`;
